module.exports = __webpack_public_path__ + "static/media/timesheet_submission.2e524e33.png";